export default "__VITE_ASSET__C0H4BPAb__"